import { render } from "./sortOnlyItinerary.vue?vue&type=template&id=55d554df"
import script from "./sortOnlyItinerary.vue?vue&type=script&lang=js"
export * from "./sortOnlyItinerary.vue?vue&type=script&lang=js"

import "./sortOnlyItinerary.vue?vue&type=style&index=0&id=55d554df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__